import { CartInfo } from "src/types/cartInfo";
import { Cart, LineItem, Money } from "src/types/ctgraphql.d";

export const getCartItemsCount = (lineItems?: LineItem[]): number =>
  lineItems?.reduce(
    (sum, item) => sum + ((item?.quantity as number) || 0),
    0
  ) || 0;

export const getLineItemsTotal = (lineItems?: LineItem[]): Money | null => {
  if (!lineItems?.length) {
    return null;
  }

  const reference = lineItems[0]?.price?.value;

  if (!reference) {
    return null;
  }

  const centAmount = lineItems.reduce((sum, item) => {
    const value = (item?.price?.value?.centAmount as number) || 0;
    const quantity = (item?.quantity as number) || 0;

    return sum + value * quantity;
  }, 0);

  return { ...reference, centAmount } as Money;
};

export const getCartInfo = (cart?: Cart | null): CartInfo => ({
  id: cart?.id || "",
  version: (cart?.version as number) || 0,
});
